import { gql } from "@apollo/client";

export const GET_FEATURES = gql`
  query featureSection($locale: I18NLocaleCode) {
    featureSection(locale: $locale) {
      features {
        icon
        title
        description
      }
    }
  }
`;

export const GET_CARDS = gql`
  query cardSection($locale: I18NLocaleCode) {
    cardSection(locale: $locale) {
      cards {
        documentId
        icon
        title
        description
        descriptionPt2
      }
    }
  }
`;

export const GET_INIT = gql`
  query init($locale: I18NLocaleCode) {
    header(locale: $locale) {
      getRobustText
      aboutUsText
      contactText
      faqText
      loginText
      loginLink
      logo {
        alternativeText
        url
      }
    }
    cookieConsent(locale: $locale) {
      title
      text
      readMoreText
      approveButtonText
      declineButtonText
    }
  }
`;
export const GET_HERO = gql`
  query heroSection($locale: I18NLocaleCode) {
    heroSection(locale: $locale) {
      title
      subTitle
      description
      descriptionPt2
      buttonText
      image {
        alternativeText
        url
      }
    }
  }
`;
export const GET_CALLOUT = gql`
  query callout($locale: I18NLocaleCode) {
    callout(locale: $locale) {
      title
      description
      descriptionPt2
      buttonText
    }
  }
`;

export const GET_TEXTIMAGE = gql`
  query textImage($locale: I18NLocaleCode) {
    textImage(locale: $locale) {
      title
      subTitle
      description
      descriptionPt2
      buttonText
      image {
        alternativeText
        url
      }
    }
  }
`;

export const GET_TEXTIMAGEALT = gql`
  query textImageAlt($locale: I18NLocaleCode) {
    textImageAlt(locale: $locale) {
      title
      subTitle
      description
      descriptionPt2
      descriptionPt3
      buttonText
      image {
        alternativeText
        url
      }
    }
  }
`;

export const GET_FOOTER = gql`
  query getFooter($locale: I18NLocaleCode) {
    footer(locale: $locale) {
      logo {
        url
        alternativeText
      }
      copyright
      policiesTitle
      contact {
        title
        email
        emailLabel
        phone
        phoneLabel
        organizationNumber
        organizationNumberLabel
      }
    }
    policy(locale: $locale) {
      privacyPolicyTitle
      cookiePolicyTitle
    }
  }
`;


export const GET_ABOUTSECTION = gql`
  query getAboutSection($locale: I18NLocaleCode) {
    aboutSection(locale: $locale) {
      aboutTitle
      partnerTitle
      aboutHeroTitle
      aboutHeroImage {
        url
        alternativeText
      }
      content {
        __typename

        ... on ComponentAboutText {
          id
          Title
          Text
        }

        ... on ComponentAboutQuote {
          id
          quote
          quoteBy
          image {
            url
            alternativeText
          }
        }

        ... on ComponentAboutPartner {
          id
          name
          partnerUrl
          image {
            url
            alternativeText
          }
        }
      }
    }
  }
`;

export const GET_CONTACTSECTION = gql`
  query getContact($locale: I18NLocaleCode) {
    contactSection(locale: $locale) {
      title
      subHeading
      buttonText
      nameLabel
      emailLabel
      phoneLabel
      messageLabel
      policyLabel
      errorMessage
      validationMessage
      resetFormText
    }
  }
`;

export const GET_COOKIEPOLICY = gql`
  query getCookiePolicy($locale: I18NLocaleCode) {
    policy(locale: $locale) {
      cookiePolicy
      cookiePolicyTitle
    }
  }
`;
export const GET_PRIVACYPOLICY = gql`
  query getPrivacyPolicy($locale: I18NLocaleCode) {
    policy(locale: $locale) {
      privacyPolicy
      privacyPolicyTitle
    }
  }
`;

export const GET_FAQSECTION = gql`
  query getFaqSection($locale: I18NLocaleCode) {
    faqSection(locale: $locale) {
      title
      image {
        url
        alternativeText
      }

      content {
        __typename

        ... on ComponentFaqQuestionAnswer {
          id
          question
          answer
        }
      }
    }
  }
`;

export const GET_SUBSCRIPTIONS = gql`
  query getSubscriptions($locale: I18NLocaleCode) {
    subscriptions(sort: "order:asc", locale: $locale) {
      documentId
      title
      price
      tagline
      highlighted
      noEmployees
      secondary
      users
      workplaces
      buttonText
      order
      featuresList {
        name
        included
      }
      additionalModules {
        documentId
        name
      }
      baseModules {
        documentId
        name
      }
      includedProcesses
    }
  }
`;

export const GET_ADDITIONAL_MODULES = gql`
  query GetAdditionalModules($locale: I18NLocaleCode) {
    additionalModules(pagination: { limit: -1 }, locale: $locale) {
      documentId
      name
      description
      monthlyCost
      category
      requiredBaseModule {
        documentId
        name
      }
      subscriptions {
        documentId
        title
      }
    }
  }
`;

export const GET_BASE_MODULES = gql`
  query GetBaseModules($locale: I18NLocaleCode) {
    baseModules(pagination: { limit: -1 }, locale: $locale) {
      documentId
      name
      description
      monthlyCost
      subscriptions {
        documentId
        title
      }
    }
  }
`;

export const GET_CONFIGURATION = gql`
  query getConfiguration {
    configuration {
      mailRecipant
      showPrices
      defaultUserPrice
      defaultWorkplacePrice
      defaultProcessPrice
    }
  }
`;

export const GET_PROCESSES = gql`
  query GetProcesses($locale: I18NLocaleCode) {
    processes(pagination: { limit: -1 }, locale: $locale) {
      documentId
      name
      monthlyCost
    }
  }
`;
